import ProjectIdPopup from "../../../../AddModule/ProjectId.jsx/ProjectIdPopup.js"

const PreviewPopupTable = ({projct,hidePopup}) => {

  return (
    <>
      <ProjectIdPopup onClose={hidePopup} useTableInAuditTrail={true}
        auditTrailRow={<tr>
              <td
                style={{
                  width:"250px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  // padding: "3px",
                }}
              >
                {projct.product_code}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  // padding: "3px",
                }}
              >
                {projct.description}
              </td>
          </tr>}>
      </ProjectIdPopup>
    </>
  );}

export default PreviewPopupTable